<template>
  <div class="logininside">

    <v-layout align-center column fill-heigh class="py-4 dark-bg">
        <v-flex id="loginformbox" class="text-xs-center" xs12>
          <img src="../assets/images/logo/vapp-by-finanzchecks-long-logo-singleline.svg" alt="VAPP by Finanzchecks - Logo - Single line" />
          <img src="../assets/images/logo/versicherungsapp-fuer-unternehmen-vapp.gif" alt="VAPP - Versicherungs-APP für Unternehmen, Freiberufler und Selbstständige - Typewriter Animation" />
          <v-form ref="loginform" class="pl-md-5 px-4 py-3" v-model="valid" lazy-validation @submit.prevent="login" autocomplete="on">
            <div>
              <v-alert class="mb-3" :value="true" v-if="loginemailerror" color="error" icon="warning" outline>Die angegebene E-Mail-Adresse ist VAPP unbekannt.</v-alert>
              <v-alert class="mb-3" :value="true" v-if="notpublishederror" color="error" icon="warning" outline>Der angegebene Account ist gelöscht worden oder deaktiviert. Bitte wenden Sie sich an uns, wenn der Anmeldeversuch weiterhin nicht funktioniert.</v-alert>
              <v-alert class="mb-3" :value="true" v-if="loginpwerror" color="error" icon="warning" outline>Das angegebene Passwort ist falsch.</v-alert>
              <v-text-field
                ref="email"
                v-model="email"
                type="email"
                name="email"
                maxlength="120"
                :rules="[rules.required, rules.email]"
                :error="loginemailerror"
                label="E-Mail-Adresse *"
                dark
                placeholder
                clearable
                @keyup="checkEMailKeyup"
                autocomplete="username"
                required
              />

              <v-text-field
                v-model="pw_val1"
                :append-icon="password_1 ? 'visibility_off' : 'visibility'"
                :rules="[rules.required, rules.min, rules.password]"
                :type="password_1 ? 'text' : 'password'"
                :error="loginpwerror"
                name="password_1"
                label="Passwort"
                dark
                maxlength="24"
                @click:append="password_1 = !password_1"
                @keyup="checkPasswordKeyup"
                autocomplete="current-password"
                required
              />

              <div class="text-xs-left">
                <a href="#" @click.stop.prevent="getpwtoken_dialog = true" color="red">Passwort vergessen?</a>
              </div>
            </div>

            <v-layout align-center fill-heigh justify-space-between class="py-4">
                <v-btn v-if="loginemailerror || loginpwerror" href="https://v2.zopim.com/widget/livechat.html?hostname=vapp.finanzchecks.de&key=3URHcLrIcpBtQzKYHVqmHp9JpCsa3EUZ&lang=de" target="_blank" flat small dark style="margin-left: -5px;" title="Hierbei wird ein Chat zu einem Mitarbeiter geöffnet in einem neuen Fenster via ZenDesk geöffnet">Probleme beim anmelden?</v-btn>
                <v-spacer />
                <v-btn class="mx-0" color="white" :loading="loading" :disabled="loading" @click="login">Anmelden</v-btn>
            </v-layout>
          </v-form>
        </v-flex>

        <v-flex v-if="show_alt_logins" id="socialloginbox" xs12 md6 class="mt-4 d-block registerproviderbox">
            <div class="text-xs-center white--text pb-3">&hellip; oder anmelden mit:</div>
            <v-btn color="white" @click="login_google()"><img :src="require('../assets/images/google_icon.svg')" alt="g+" /> Mit Google anmelden </v-btn>
            <v-btn color="white" @click="login_apple()"><img :src="require('../assets/images/apple_icon.svg')" alt="🍏" /> Mit Apple anmelden </v-btn>
        </v-flex>
    </v-layout>


    <section id="archievbox">
      <v-sheet color="transparent" dark>
          <v-layout justify-space-between row fill-height class="dark-bg archievbox">
            <v-flex sm6>
                <header>
                    <h1 class="headline">VAPP - Versicherungs-APP</h1>
                </header>
                <p>Versicherungen digitalisiert für<br/> Selbstständige, Freiberufler &amp; Unternehmen</p>
            </v-flex>
            <v-flex sm6>
                <iframe height="415" width="415" src="https://www.youtube-nocookie.com/embed/i6KHx7Lio88" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
            </v-flex>
          </v-layout>
          <v-layout v-for="(row, index) in achievementsitems" :key="`usp-card-${index}`" justify-space-between row :reverse="index%2==0" fill-height :class="index%2==0 ? `text-md-right dark-bg archievbox` : `dark-bg archievbox`">
            <v-flex sm6>
                <h2 class="headline">{{ row.title }}</h2>
                <p>{{ row.content }}</p>
            </v-flex>
            <v-flex sm6>
                <v-img :src="`img/usp-slider/${row.filename}`"></v-img>
            </v-flex>
          </v-layout>
      </v-sheet>
    </section>


    <v-dialog v-model="getpwtoken_dialog" absolute max-width="650" dark persistent>
        <v-form ref="getpwtoken" v-model="getpwtoken_valid" lazy-validation @submit.prevent="sendPasswordToken">
            <v-card>
                <v-card-title class="headline">Passwort zurücksetzen lassen</v-card-title>
                <v-card-text>
                    <p>Bitte geben Sie hier Ihre bei VAPP/ Finanzchecks hinterlegte (Unternehmens-)&shy; E-Mail-Adresse ein, sodass wir Ihnen eine E-Mail schicken können, mit der Sie die Möglichkeit erhalten ein neues Passwort zu vergeben.</p>
                    <v-alert class="mb-3" :value="true" v-if="loginemailerror" color="error" icon="warning" outline>Die angegebene E-Mail-Adresse ist VAPP unbekannt.</v-alert>
                    <v-text-field 
                        v-model="email" 
                        type="email" 
                        name="email" 
                        maxlength="120" 
                        :rules="[rules.required, rules.email]" 
                        :error="loginemailerror" 
                        label="E-Mail-Adresse *" 
                        placeholder 
                        clearable 
                        @keyup="loginemailerror = false" 
                        required 
                    />
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-btn flat @click="getpwtoken_dialog=false">Abbrechen</v-btn>
                    <v-spacer />
                    <v-btn color="black" dark :disabled="(!getpwtoken_valid || !email || loading)" :loading="loading" @click="sendPasswordToken">Zurücksetzung anfodern</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>


    <v-dialog v-model="setnewpw_dialog" absolute max-width="650" dark persistent>
        <v-form ref="setnewpw_form" v-model="setnewpw_valid" lazy-validation @submit.prevent="sendNewPassword">
            <v-card>
                <v-card-title class="headline">Passwort vergeben &amp; loslegen</v-card-title>
                <v-card-text>
                    <p>Bitte geben Sie hier Ihre bei VAPP/ Finanzchecks hinterlegte (Unternehmens-)E-Mail-Adresse und Ihr gewünschtes Passwort zum künftigen Anmelden bei VAPP ein. <br/>Im Anschluss können Sie sofort VAPP (weiter-)verwenden.</p>
                    <v-text-field 
                        v-model="email" 
                        type="email" 
                        name="email" 
                        maxlength="120" 
                        :rules="[rules.required, rules.email]" 
                        :error="loginemailerror" 
                        label="E-Mail-Adresse *" 
                        placeholder 
                        clearable 
                        @keyup="loginemailerror = false" 
                        required 
                    />
                    <v-text-field
                        v-model="register_pw1_val"
                        :append-icon="register_pw1 ? 'visibility_off' : 'visibility'"
                        :rules="[rules.required, rules.min, rules.password]"
                        :type="register_pw1 ? 'text' : 'password'"
                        name="register_pw1"
                        label="Passwort"
                        hint="Mindestens 6 Zeichen eingeben"
                        maxlength="24"
                        @click:append="register_pw1 = !register_pw1"
                        required
                    />
                    <v-text-field
                        v-model="register_pw2_val"
                        :append-icon="register_pw2 ? 'visibility_off' : 'visibility'"
                        :rules="[rules.required, rules.min, comparePasswords, rules.password]"
                        :type="register_pw2 ? 'text' : 'password'"
                        name="register_pw2"
                        label="Passwort wiederholen"
                        hint="Mindestens 6 Zeichen eingeben"
                        maxlength="24"
                        @click:append="register_pw2 = !register_pw2"
                        @keyup.enter="(setnewpw_valid) ? sendNewPassword() : null"
                        required
                    />
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-btn flat @click="setnewpw_dialog = false">Abbrechen</v-btn>
                    <v-spacer />
                    <v-btn color="black" dark :disabled="(!setnewpw_valid || !email || !register_pw1_val || !register_pw2_val || loading)" :loading="loading" @click="sendNewPassword">Passwort speichern und anmelden</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>

    <v-dialog v-model="wrong_loginprovider_dialog" dark absolute max-width="600" persistent>
          <v-card>
              <v-card-text>
                   <p>Wir konnten keinen registrierten Nutzer mit der eingegebenen E-Mail-Adresse in unserem System finden.</p>
                   <p>Bitte loggen Sie sich zunächst mit der bei uns hinterlegten E-Mail-Adresse ein. Sollten Sie noch kein Passwort vergeben haben, klicken Sie bitte auf „<a @click="getNewPasswordWindow">Passwort vergessen</a>“.</p>
                   <p>Anschließend können Sie unter „Einstellungen“ den Login mit Google oder Apple verknüpfen.</p>
              </v-card-text>
              <v-divider />
              <v-card-actions>
                  <v-spacer />
                  <v-btn color="black" dark @click="wrong_loginprovider_dialog = false">Verstanden</v-btn>
                  <v-spacer />
              </v-card-actions>
          </v-card>
    </v-dialog>

    <v-dialog v-model="different_provider_dialog" absolute max-width="600" persistent>
        <v-card>
            <v-card-title class="headline">
                <v-icon color="warning" left>warning</v-icon>Andere Anmeldemethode wählen
            </v-card-title>
            <v-card-text>
                <p>Sie haben ein Account bei VAPP über eine andere Anmeldemethode (Apple, Google, E-Mail) registriert. Bitte verwenden Sie die zur Registrierung genutzte Methode, damit Ihre Daten nicht verloren gehen.<br/><br/><b>Tipp:</b> Wenn Sie sich mit Ihrer ursprünglichen Registrierungsmethode angemeldet haben, finden Sie unter dem Reiter "Anmeldeeinstellungen" Optionen, um verschiedene Anmeldemethoden miteinander zu kombinieren/ hinzuzufügen; sodass Sie zukünftig über verschiedene Anmeldemethoden zu Ihren Daten gelangen.</p>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn color="black" dark @click="different_provider_dialog = false">Ok</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="install_helper_dialog" absolute scrollable max-width="600">
        <v-card>
          <v-card-title class="headline">
            <v-icon left>cloud_download</v-icon> VAPP installieren - Anleitung
          </v-card-title>
          <v-card-text class="text-xs-center">
            <p>VAPP ist eine WebApp (PWA) und kann über Ihren Webbrowser als eigenständige App installiert werden.</p>
            <img v-if="!isMobile && isChrome" :src="require('../assets/images/install_helppics/desktop-chrome_web_li.webp')" alt="kein Hilfebild zum System gefunden" class="img-fluid" />
            <img v-if="!isMobile && isEdge" :src="require('../assets/images/install_helppics/desktop-edge_web_li.webp')" alt="kein Hilfebild zum System gefunden" class="img-fluid" />
            <img v-else-if="isMobile && isIos" :src="require('../assets/images/install_helppics/iphone-safari-5_web_li.webp')" alt="kein Hilfebild zum System gefunden" class="img-fluid" />
            <img v-else :src="require('../assets/images/install_helppics/andriod-chrome_web_li.webp')" alt="kein Hilfebild zum System gefunden" class="img-fluid" />
          </v-card-text>
          <v-divider />
          <v-card-actions style="justify-content: flex-end;">
            <v-btn color="black" dark @click="install_helper_dialog = false">Ok</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>

    <v-fade-transition>
        <div v-if="loading" id="fakesplashscreen" :class="{ mobile: isMobile }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 239.35 198.86" id="vapp-btm-logo"><path class="vapp-logo-right-v" d="M123.69,188.82H227.24L167.59,24.76l-62.75,172.5h-9L167.59,0l71.76,197.27H123.69Z"/><path class="vapp-logo-left-v" d="M28.14,1.59H143.52L71.76,198.86,0,1.59H9l62.75,172.5L131.42,10H28.14Z"/></svg>
            <v-progress-circular indeterminate color="grey lighten-2" :width="2"></v-progress-circular>
            <img id="vapp-subline-img" src="@/assets/images/logo/subline-only_1.svg" alt="Versicherungs-APP by Finanzchecks" />
        </div>
    </v-fade-transition>

  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import { IS_MOBILE } from '@/constants.js';

export default {
  data: () => ({
    afterloginpath: '/',
    getpwtoken_dialog: false,
    getpwtoken_valid: false,
    wrong_loginprovider_dialog: false,
    register_email: null,
    register_pw1: null,
    register_pw2: null,
    register_pw1_val: null,
    register_pw2_val: null,
    register_origin: 'vapp',
    email: undefined,
    valid: false,
    registerstep_isvalid: false,
    loginemailerror: false,
    notpublishederror: false,
    register_loginemailerror: false,
    loginpwerror: false,
    pw_val1: '',
    show_alt_logins: true,
    password_1: false,
    loading: false,
    different_provider_dialog: false,
    install_helper_dialog: false,
    // genNewPasswordMode: false,
    rules: {
      required: value => !!value || 'Pflichtfeld - Bitte ausfüllen',
      min: v => (v || '').length >= 6 || 'Geben Sie mindestens 6 Zeichen ein',
      email: v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(v) || 'Bitte eine gültige E-Mail-Adresse eingeben'
      },
      password: v => {
        const pattern = /^(?=.*\d)(?=.*[A-Za-z])[0-9A-Za-z!?:_@#$%().=,-äöüßÄÖÜ]{6,24}$/
        return (pattern.test(v) || v=='') || 'Bitte verwenden Sie Buchstaben und Zahlen für Ihr Passwort. Bei Bedarf können folgende Sonderzeichen verwendet werden: @ # $ % ( ) ! ? : _ - . = , ä ö ü ß Ä Ö Ü'
      }
    },
    achievementsitems: [
      {
        title: `VAPP - Als App (PWA) oder Website`,
        content: `Aufgrund der Symbiose aus einer responsiven Webseite und einer App können Sie VAPP auf jedem Endgerät nutzen.`,
        filename: `VAPP-PWA-Device.webp`
      },
      {
        title: `Datenmanagement`,
        content: `1-Mal Anschrift oder Namen ändern - alle Versicherer die bei VAPP von Ihnen freigeschaltet wurden, werden automatisch informiert.`,
        filename: `VAPP-Datenmanagement.webp`
      },
      {
        title: `Vertragsmanagement`,
        content: `1 Login - Ihre gewünschten Versicherungsverträge digitalisiert. Sie können Verträge selbst verwalten oder den kostenfreien VAPP-Service nutzen.`,
        filename: `VAPP-Vertragsmanagement.webp`
      },
      {
        title: `Kostenfreier VAPP-Service`,
        content: `Automatische Aktualisierung Ihrer Vertragsdaten- und Dokumente mit über hundert Versicherungen. Wir informieren Sie, wenn sich etwas an Ihrem Vertrag geändert hat oder Sie ein neues Dokument erhalten haben.`,
        filename: `VAPP-Service.webp`
      },
      {
        title: `1 Ansprechpartner`,
        content: `Nutzen Sie den direkten Kontakt über den VAPP-CHAT oder die telefonische Beratung zu all Ihren Verträgen z.B. bei einem Schadenfall oder für eine aktuelle Versicherungsbestätigung.`,
        filename: `VAPP-CHAT.webp`
      },
      {
        title: `Bedarfsanalyse`,
        content: `Erhalten Sie von unseren Versicherungsexperten wichtige Tipps & Angebote, um finanzielle Risiken für Ihr Unternehmen zu minimieren.`,
        filename: `VAPP-Bedarfsanalyse.webp`
      },
      {
        title: `Nützliche Tools`,
        content: `Wir informieren Sie rechtzeitig, bevor sich ein Vertrag verlängert und prüfen auf mögliche Optimierung. Ein Tarifwechsel erfolgt ausschließlich mit Ihrem Einverständnis.`,
        filename: `VAPP-Versicherung-fuer-Unternehmer.webp`
      }
    ],
    setnewpw_dialog: false,
    setnewpw_valid: false,
  }),

    computed: {
        comparePasswords(){
            return this.register_pw1_val !== this.register_pw2_val ? 'Die Passwörter stimmen nicht überein' : true
        },
        isInStandaloneMode(){
            return window.matchMedia('(display-mode: standalone)').matches;
        },
        isIos(){
            if(/iPhone|iPad|iPod/i.test(navigator.platform)){
                return true;
            }else{
                return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
            }
        },
        isChrome(){
            return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) && !/Edg/.test(navigator.userAgent);
        },
        isEdge(){
            return /Edg/.test(navigator.userAgent);
        },
        isMobile(){
            return IS_MOBILE();
        }
    },

  watch: {
      different_provider_dialog (){
          if(this.different_provider_dialog){
            this.$store.dispatch('chat/sendAdminMail', {
                subject: `Falsche Anmeldemethode verwendet: ${this.email}`,
                content1: `Der Benutzer (E-Mail-Adresse: ${this.email}) hat verucht sich mit einer falschen Anmeldemethode anzumelden.`,
                kind: `MESSAGE`,
                heading: `Falsche Anmeldemethode`
            });
          }
      }
  },


  mounted: function () {
      if(!_.isEmpty(this.$route.query.email) && !_.isEmpty(this.$route.query.pw)){
          this.login();
      }
  },


  created(){
      if(this.$route.query.redirect){
          if(!_.isEmpty(this.$route.query.redirect)){
              this.afterloginpath = this.$route.query.redirect;
          }
      }
      // console.log('this.$store.state.user.data.accept_cookies :>> ', this.$store.state.user.data.accept_cookies);
      // if(!_.isEmpty(this.$route.query.pw_reset)){
      //   this.afterloginpath = '/accountsettings';
      // }
      if(!_.isEmpty(this.$route.query.email)){
          this.email = this.$route.query.email;
      }
      if(!_.isEmpty(this.$route.query.verify)){
          this.show_alt_logins = false;
          if(this.$route.query.verify=='1'){
              this.$snotify.success('E-Mail-Verifikation erfolgreich abgeschlossen');
          }else{
              this.$snotify.error('Der angegebene Token ist ungültig. Bitte versuchen Sie es erneut, oder kontaktieren Sie unseren Support.');
          }
      }
      if(!_.isEmpty(this.$route.query.token)){
          this.$snotify.simple('Bitte ein Passwort wählen und bestätigen');
          this.setnewpw_dialog = true;
      }else if(!_.isEmpty(this.$route.query.getnewpass)){
          this.getpwtoken_dialog = true;
      }else{
          if(!_.isEmpty(this.$route.query.email)){
              this.show_alt_logins = false;
          }
          if(!_.isEmpty(this.$route.query.origin)){
              this.register_origin = this.$route.query.origin;
              this.show_alt_logins = false;
          }
          // try2autologin
          if(!this.$route.query.redirect){
              if(this.$store.state.auth.fb){
                  if(this.$store.state.auth.fb.uid !== null && this.$store.state.auth.fb.uid !== undefined){
                      this.$router.push({ path: this.afterloginpath });
                  }else{
                      this.$store.dispatch('auth/tryAutoLogin', {topath: this.afterloginpath}).catch(() => null);
      
                  }
              }
          }
      }
      this.$store.state.user.data.origin = this.register_origin;
  },

  methods: {
    getNewPasswordWindow(){
        this.wrong_loginprovider_dialog = false;
        this.getpwtoken_dialog = true;
    },

    checkEMailKeyup(e){
        (e.key==='Enter') ? this.login() : this.loginemailerror = false;
    },

    checkPasswordKeyup(e){
        (e.key==='Enter') ? this.login() : this.loginpwerror = false;
    },

    login(){
        this.loading = true;
        // this.$snotify.simple('Wird angemeldet ...');
        if(this.$refs.loginform.validate()){
            firebase.auth().signInWithEmailAndPassword(this.email, this.pw_val1).then(({user}) => {
                //console.log(user);
                if(this.$store.getters['user/getUsersCookieConsent']=='all'){
                    firebase.analytics().logEvent('login', { method: 'EmailAndPassword' });
                };
                this.$store.dispatch('auth/setUserAuth', {user, topath:this.afterloginpath}).then(() => {
                      setTimeout(() => this.loading = false, 280);  // --> just 4 more splashscreen-time
                }).catch(error => {
                    if(error=='User not published'){
                        this.notpublishederror = true;
                        // this.$snotify.error("Dieser Account ist nicht freigegeben.");
                        this.$snotify.error('Der Account ist gesperrt oder gelöscht');
                    }else{
                        this.loginemailerror = true;
                        this.$snotify.error("Dieser Account ist uns unbekannt.");
                    }
                    this.loading = false;
                    this.$snotify.clear();
                });
            }).catch(error => {
                // console.log(error.response.status);
                let code = error.code;
                this.loading = false;
                this.$snotify.clear();
                if(code === 'auth/user-not-found' || code === 'auth/wrong-password'){
                    if(code === 'auth/user-not-found'){
                        this.loginemailerror = true;
                    }
                    if(code === 'auth/wrong-password'){
                        this.loginpwerror = true;
                    }
                    return
                };
                if(code==='auth/account-exists-with-different-credential'){
                    this.email = error.email;
                    this.different_provider_dialog = true;
                    return
                };
                if(code === 'auth/user-disabled'){
                    this.notpublishederror = true;
                    this.$snotify.error('Der Account ist gesperrt oder gelöscht');
                }else{
                    this.$snotify.error(error.message);
                };
            });
        }else{
            this.loading = false;
        }
    },

    login_google(){
        var provider = new firebase.auth.GoogleAuthProvider();
        this.loading = true;
        firebase.auth().useDeviceLanguage();
        firebase.auth().signInWithPopup(provider).then((result) => {
            if(this.accept_cookies=='all'){
                firebase.analytics().logEvent('login', { method: 'Google' });
            };
            console.log('result, signIn :>> ', result, result.operationType);
            if(result.additionalUserInfo.isNewUser){  // if register
                this.$snotify.error('Falsche Anmeldemethode');
                result.user.delete().then(() => {
                    this.wrong_loginprovider_dialog = true;
                });
                this.loading = false;
                return null;
            };
            if(result.user && result.user.emailVerified === false) {
                this.$store.dispatch('auth/sendEmailVerification', 'Ihre E-Mail-Adresse bestätigen').then(response => {
                    this.$store.dispatch('auth/setUserAuth', {user: result.user, topath:this.afterloginpath});
                    this.$snotify.success('Verifikations-E-Mail wurde gesendet');
                    this.loading = false;
                }).catch(error => {
                    this.$snotify.error('Die E-Mail zur Verifikation Ihrer Adresse kann aktuell nicht versendet werden. Bitte später nocheinmal versuchen.');
                    this.loading = false;
                });
            }else{
                this.$store.dispatch('auth/setUserAuth', {user: result.user, topath:this.afterloginpath}).catch(error => {
                    this.loading = false;
                    this.$snotify.clear();
                    this.loginemailerror = true;
                    this.$snotify.error("Dieser Account ist uns unbekannt.");
                });
                this.loading = false;
            };
        }).catch((error) => {
            this.loading = false;
            this.$snotify.clear();
            if(error.code==='auth/account-exists-with-different-credential'){
                this.email = error.email;
                this.different_provider_dialog = true;
            }else if(error.code === 'auth/user-disabled'){
                this.notpublishederror = true;
                this.$snotify.error('Der Account ist gesperrt oder gelöscht');
            }else{
                console.error(error);
                this.$snotify.error('Bitte später nocheinmal versuchen', 'Fehler');
            }
        });
    },

    login_apple(){
        var provider = new firebase.auth.OAuthProvider('apple.com');
        provider.setCustomParameters({
            locale: 'de'
        });
        this.loading = true;
        firebase.auth().signInWithPopup(provider).then(result => {
            if(this.accept_cookies=='all'){
                firebase.analytics().logEvent('login', { method: 'Apple' });
            };
            if(result.additionalUserInfo.isNewUser){  // if register
                this.$snotify.error('Falsche Anmeldemethode');
                result.user.delete().then(() => {
                    this.wrong_loginprovider_dialog = true;
                });
                this.loading = false;
                return null;
            };
            if(result.user && result.user.emailVerified === false) {
                this.$store.dispatch('auth/sendEmailVerification', 'Ihre E-Mail-Adresse bestätigen').then(response => {
                  this.$store.dispatch('auth/setUserAuth', {user: result.user, topath:this.afterloginpath});
                    this.$snotify.success('Verifikations-E-Mail wurde gesendet');
                    this.loading = false;
                }).catch(error => {
                    this.$snotify.error('Die E-Mail zur Verifikation Ihrer Adresse kann aktuell nicht versendet werden. Bitte später nocheinmal versuchen.');
                    this.loading = false;
                });
            }else{
                this.$store.dispatch('auth/setUserAuth', {user: result.user, topath:this.afterloginpath}).catch(error => {
                    this.loading = false;
                    this.$snotify.clear();
                    this.loginemailerror = true;
                    this.$snotify.error("Dieser Account ist uns unbekannt.");
                });
                this.loading = false;
            };
        }).catch(error => {
            this.loading = false;
            this.$snotify.clear();
            if(error.code==='auth/account-exists-with-different-credential'){
                this.email = error.email;
                this.different_provider_dialog = true;
            }else if(error.code === 'auth/user-disabled'){
                this.notpublishederror = true;
                this.$snotify.error('Der Account ist gesperrt oder gelöscht');
            }else{
                console.error(error);
                this.$snotify.error('Bitte später nocheinmal versuchen', 'Fehler');
            }
        });
    },

    sendPasswordToken(){
        if(this.getpwtoken_valid){
            this.loading = true;
            this.$store.dispatch('auth/sendPwForgetEmail', this.email).then(response => {
                this.$snotify.success('E-Mail zur Bestätigung wurde versendet');
                this.getpwtoken_dialog = false;
            }).catch(error => {
                console.log('sendPwForgetEmail-majorerr :>> ', error);
                if(error=='Error: "Network Error"'){
                    this.$snotify.error('Netzwerkfehler - bitte Support kontaktieren', 'Fehler');
                }else{
                    this.loginemailerror = true;
                    this.$snotify.error('Bitte später nocheinmal versuchen oder einen anderen Web-Browser verwenden', 'Fehler');
                };
            }).finally(() => {
                this.loading = false;
            });
        }else{
            this.$snotify.error('Die Eingabe konnte so nicht angenommen werden', 'Fehler');
        }
    },

    sendNewPassword(){
        if(this.setnewpw_valid){
            this.loading = true;
            this.pw_val1 = this.register_pw1_val;
            this.$store.dispatch('auth/setPassword', {email: this.email, password: this.register_pw1_val, token: this.$route.query.token}).then(() => {
                this.$snotify.success('Neues Passwort wurde gespeichert - wird angemeldet ...');
                this.setnewpw_dialog = false;
                this.login();
            }).catch(status_code => {
                if(status_code==410){
                    this.$snotify.error('Token ist ungültig oder wurde bereits verwendet - Bitte erneut versuchen', 'Token-Problem', {timeout:6000});
                }else if(status_code==420 || status_code==500){
                    this.$snotify.error('Ihr Profil konnte nicht gefunden werden - Bitte E-Mail-Adresse prüfen', 'Account-Problem', {timeout:6000});
                }else{
                  this.$snotify.error('Bitte später nocheinmal versuchen oder einen anderen Web-Browser verwenden', 'Fehler', {timeout:6000});
                };
                this.loading = false;
            });
        }else{
            this.$snotify.error('Die Eingaben sind nicht korrekt - bitte alles ausfüllen', 'Fehler');
        }
    }

  }
}
</script>

<style scoped>
  .registerproviderbox{
    display: flex;
    flex-direction:column;
  }
  .registerproviderbox .v-btn img, .registerproviderbox .v-btn .v-icon{
    height: 1em;
    font-size: 1.4em;
    width: auto;
    margin-right: 0.5em;
  }
  .loginbuttonbox{
    border-right: 1px solid #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction:column;
  }
  .loginbuttonbox>button:first-child{
    margin-top: -3rem;
  }
  #loginformbox{
    min-width: 500px;
  }
  #loginformbox form{
    max-width: 450px;
    margin: 0 auto;
  }
  #loginformbox>img{
    width: 85%;
    height: auto;
  }
  #vapp-subline-img{
    height: 7.5vh;
  }
  #vapp-btm-logo{
    height: 20vh;
  } 
  #fakesplashscreen{
    position:fixed;
    top:0;
    left:0;
    width:100vw;
    height:100vh;
    background-color:#212121;
    display:flex;
    z-index:9;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 30vh 0 7.5vh;
  }
  #fakesplashscreen.mobile{
    padding: 20vh 0;
  }
  #fakesplashscreen>.v-progress-circular{
    position:absolute;
    bottom:20vh;
  }
  #fakesplashscreen.mobile>.v-progress-circular{
    bottom:35vh;
  }
  #regist_logo{
    width: 300px;
    height: auto;
    margin:0 auto 1.5rem;
    max-width: 100%;
  }
  #installbtn>button .v-icon{
    position: absolute;
    text-align: 0;
    height: 36px;
    background-color: #000;
    top: -8px;
    left: -16px;
    color: #fff;
    padding: 10px;
  }
  #installbtn>button span{
    padding-left:40px;
  }
  #archievbox{
    margin: 3rem 0;
  }
  .archievbox{
    margin-bottom: 2rem;
  }
  .archievbox>*{
    padding: 4rem;
    align-self:center;
  }
  .archievbox>* h2, #archievbox h1{
    margin-bottom: 1rem;
    font-size: 22px !important;
  }
  .archievbox>* p{
    font-size: 20px;
    font-weight: 300;
  }
  .archievbox>* .v-image, .archievbox>* iframe{
    border-radius:.5rem;
    box-shadow:0px 3px 5px -1px rgba(0,0,0,0.5), 0px 5px 8px 0px rgba(0,0,0,0.5), 0px 1px 14px 0px rgba(0,0,0,0.5);
    max-width: 100%;
  }
  .theme--light.v-table.v-datatable{
    background-color:transparent;
  }
  .theme--light.v-table.v-datatable th{
    vertical-align: middle;
  }


  @media screen and (max-width: 768px) {
    .loginbuttonbox>button:first-child{
      margin-top: 0;
    }
    .loginbuttonbox{
      border-right: none;
    }
    #loginformbox{
      min-width: inherit;
      width:100%;
    }
    #socialloginbox{
      text-align: center;
    }
    #socialloginbox>button, #installbtn>button, #installbtn{
      width: 100%;
    }
    .pl-5{
      padding:0!important;
    }
    .v-card__title.title .v-avatar.subheading {
      height: 24px;
      width: 24px;
      position: absolute;
      right: 15px;
      top: 15px;
    }
    #regist_logo{
      width: 80%; margin: 1.5rem auto;
    }
  }

  @media screen and (max-width: 600px) {
    .archievbox{
      padding: 2rem 1rem 1rem;
      -ms-flex-direction: column!important;
      flex-direction: column!important;
    }
    .archievbox>*{
      padding: 0;
      width: 100%;
      text-align: center;
    }
    .archievbox>* .v-image{
      box-shadow: none;
    }
  }
</style>
